export default __webpack_public_path__ + "static/media/reload (1).e96d30fd.svg";